module.exports = function( $ ) {
    var $scope = $( this ), gallery = $scope.find( '.elementor-image-gallery' )[0];
    if ( ! gallery ) return;
    var previous = $scope.data( 'iqitGalleryCleanup' );
    if ( previous && $scope.data( 'iqitGalleryElement' ) === gallery ) return;
    if ( previous ) previous();

    var doc = gallery.ownerDocument, view = doc.defaultView,
        grid = gallery.querySelector( '.gallery' ),
        items = grid.querySelectorAll( '.gallery-item' ),
        button = gallery.querySelector( '.gallery-show-more-btn' ),
        modal = gallery.querySelector( '.iqit-gallery-modal' ),
        jq = view.jQuery || $, nativeModal = view.bootstrap && view.bootstrap.Modal,
        instance, swiper, clickedIndex = 0, trigger, disposed = false, observer,
        animationTimer, resizeTimer, closing = false;

    function updateCollapsed() {
        if ( disposed || ! button || ! grid.classList.contains( 'gallery-collapsed' ) ) return;
        var columns = parseInt( view.getComputedStyle( gallery ).getPropertyValue( '--iqit-gallery-columns' ), 10 ) || 4;
        columns = Math.max( 1, Math.min( 12, columns ) );
        Array.prototype.forEach.call( items, function( item, i ) { item.hidden = i >= columns; } );
        button.parentNode.hidden = items.length <= columns;
    }

    function expanded() {
        grid.style.height = '';
        grid.style.overflow = '';
        grid.classList.remove( 'gallery-expanding' );
        grid.removeEventListener( 'transitionend', expanded );
        view.clearTimeout( animationTimer );
    }

    function showMore() {
        var height = grid.offsetHeight;
        grid.classList.remove( 'gallery-collapsed' );
        Array.prototype.forEach.call( items, function( item ) { item.hidden = false; } );
        button.setAttribute( 'aria-expanded', 'true' );
        button.parentNode.hidden = true;
        if ( view.matchMedia && view.matchMedia( '(prefers-reduced-motion: reduce)' ).matches ) return;
        grid.style.height = height + 'px';
        grid.style.overflow = 'hidden';
        grid.classList.add( 'gallery-expanding' );
        grid.getBoundingClientRect();
        grid.style.height = grid.scrollHeight + 'px';
        grid.addEventListener( 'transitionend', expanded );
        animationTimer = view.setTimeout( expanded, 650 );
    }

    function onShown() {
        if ( disposed ) { closeModal(); return; }
        var SwiperClass = view.Swiper || window.Swiper;
        if ( ! swiper ) {
            swiper = new SwiperClass( modal.querySelector( '.iqit-gallery-swiper' ), {
                initialSlide: clickedIndex, spaceBetween: 20, watchOverflow: true,
                keyboard: { enabled: true },
                navigation: { nextEl: modal.querySelector( '.iqit-gallery-next' ), prevEl: modal.querySelector( '.iqit-gallery-prev' ) }
            } );
        } else {
            swiper.update();
            swiper.slideTo( clickedIndex, 0 );
            if ( swiper.keyboard ) swiper.keyboard.enable();
        }
    }

    function removeModal() {
        if ( swiper ) { swiper.destroy( true, true ); swiper = null; }
        if ( instance ) { instance.dispose(); instance = null; }
        else if ( jq.fn.modal ) jq( modal ).modal( 'dispose' );
        if ( modal && modal.parentNode ) modal.parentNode.removeChild( modal );
    }

    function onHide() { closing = true; }

    function onHidden() {
        closing = false;
        if ( swiper && swiper.keyboard ) swiper.keyboard.disable();
        if ( disposed ) { removeModal(); return; }
        gallery.appendChild( modal );
        if ( trigger && doc.documentElement.contains( trigger ) ) trigger.focus();
    }

    function closeModal() {
        if ( instance ) instance.hide();
        else if ( modal && jq.fn.modal ) jq( modal ).modal( 'hide' );
    }

    function openModal( event ) {
        var link = $( event.target ).closest( '.js-iqit-gallery-lightbox-trigger' )[0];
        if ( ! link || ! modal || ( ! nativeModal && ! jq.fn.modal ) || ! ( view.Swiper || window.Swiper ) ) return;
        if ( link.getAttribute( 'data-gallery-target' ) !== modal.id ) return;
        event.preventDefault();
        trigger = link;
        clickedIndex = parseInt( link.getAttribute( 'data-index' ), 10 ) || 0;
        doc.body.appendChild( modal );
        if ( nativeModal ) {
            instance = instance || nativeModal.getOrCreateInstance( modal );
            instance.show();
        } else {
            jq( modal ).modal( 'show' );
        }
    }

    function onResize() {
        view.clearTimeout( resizeTimer );
        resizeTimer = view.setTimeout( updateCollapsed, 50 );
    }

    function cleanup() {
        if ( disposed ) return;
        disposed = true;
        if ( observer ) observer.disconnect();
        view.removeEventListener( 'resize', onResize );
        view.clearTimeout( resizeTimer );
        expanded();
        $( gallery ).off( '.iqitGallery' );
        if ( button ) button.removeEventListener( 'click', showMore );
        if ( modal ) {
            // Skip transitions during disposal so Bootstrap removes its own backdrop.
            modal.classList.remove( 'fade' );
            if ( modal.classList.contains( 'show' ) ) closeModal();
            else if ( ! closing ) removeModal();
        }
    }

    if ( modal ) {
        if ( nativeModal ) {
            modal.addEventListener( 'hide.bs.modal', onHide );
            modal.addEventListener( 'shown.bs.modal', onShown );
            modal.addEventListener( 'hidden.bs.modal', onHidden );
        } else {
            jq( modal ).on( 'hide.bs.modal', onHide ).on( 'shown.bs.modal', onShown ).on( 'hidden.bs.modal', onHidden );
        }
        $( gallery ).on( 'click.iqitGallery', '.js-iqit-gallery-lightbox-trigger', openModal );
    }
    if ( button ) button.addEventListener( 'click', showMore );
    updateCollapsed();
    view.addEventListener( 'resize', onResize );
    if ( view.MutationObserver ) {
        observer = new view.MutationObserver( function() {
            if ( ! doc.documentElement.contains( gallery ) ) cleanup();
        } );
        observer.observe( doc.body, { childList: true, subtree: true } );
    }
    $scope.data( 'iqitGalleryElement', gallery );
    $scope.data( 'iqitGalleryCleanup', cleanup );
};
